import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
//import {requestPassword} from '../core/_requests'
import {sendPasswordReset} from '../../../../firebase'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        // requestPassword(values.email)
        // .then(({data: {result}}) => {
        //   setHasErrors(false)
        //     setLoading(false)
        //   })
        sendPasswordReset(values.email)
        .then(() => {
          setHasErrors(false)
          setLoading(false)
        })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  return (
    <form
      className='w-100'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <h1 className='wc-auth__heading'>Forgot your password?</h1>
      <p className='wc-auth__subtitle'>Enter your email and we'll send you a reset link.</p>

      {hasErrors === true && (
        <div className='wc-auth__alert wc-auth__alert--danger' role='alert'>
          Sorry, we couldn't send the reset email. Check the address and try again.
        </div>
      )}

      {hasErrors === false && (
        <div className='wc-auth__alert wc-auth__alert--info'>
          If that email is registered, a <strong>reset link is on its way</strong> — check your inbox.
        </div>
      )}

      {/* Email */}
      <div className='wc-auth__group'>
        <label className='wc-auth__label' htmlFor='wc-auth-reset-email'>
          Email
        </label>
        <input
          id='wc-auth-reset-email'
          type='email'
          autoComplete='username'
          placeholder='you@webconstruct.com.au'
          {...formik.getFieldProps('email')}
          className={clsx('wc-auth__input', {
            'is-invalid': formik.touched.email && formik.errors.email,
          })}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='wc-auth__field-error' role='alert'>
            {formik.errors.email}
          </div>
        )}
      </div>

      <button
        type='submit'
        id='kt_password_reset_submit'
        className='wc-auth__submit'
        disabled={formik.isSubmitting || !formik.isValid}
      >
        {!loading && <span>Send reset link</span>}
        {loading && (
          <span style={{display: 'inline-flex', alignItems: 'center'}}>
            Sending…
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        )}
      </button>

      <Link to='/auth/login' className='wc-auth__ghost'>
        Back to login
      </Link>
    </form>
  )
}
